import { render } from "./itemImage.vue?vue&type=template&id=829b86b4&scoped=true"
import script from "./itemImage.vue?vue&type=script&lang=js"
export * from "./itemImage.vue?vue&type=script&lang=js"

import "./itemImage.vue?vue&type=style&index=0&id=829b86b4&scoped=scoped&lang=css"

import exportComponent from "/Users/leaf/Desktop/gmhwork/h5/zksq_H5/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-829b86b4"]])

export default __exports__